<div style="margin: 10px;">
    <div class="container" style="max-width: 100%;">
         <div style="padding: 30px 0px 30px 0px;">

            <div style="margin-bottom: 10px;">
                <input type="text" [(ngModel)]="search_name" (keyup.enter)="init_list()" class="form-control" style="width: 240px;display:inline-block;margin-right: 15px;" placeholder="請輸入想搜尋的人名後點enter">
            </div>


            <select class="form-control" style="width: 250px;display: inline-block;margin-right: 3%;" [(ngModel)]="live_type" (change)="default_page()">
                <option default disabled value="-2">請選擇直播/語聊狀態</option>
                <option *ngFor="let item of live_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <select class="form-control" style="width: 250px;display: inline-block;margin-right: 3%;" [(ngModel)]="capture_media_type" (change)="default_page()">
                <option default disabled value="-2">請選擇截圖/錄影狀態</option>
                <option *ngFor="let item of capture_media_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <select class="form-control" style="width: 250px;display: inline-block;margin-right: 3%;" [(ngModel)]="toy_type" (change)="default_page()">
                <option default disabled value="-2">請選擇玩具狀態</option>
                <option *ngFor="let item of toy_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

        </div>



        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent" [data]="data" (sortdata)="handlesortdata($event)">
           <ng-template let-post #operation_dk>
                <!-- Live 狀態切換 -->
                <div *ngIf="post.key == 'live'">
                    <div class="modern-toggle"
                         [ngClass]="post.val.live == '1' ? 'active' : 'inactive'"
                         (click)="autoToggle('live', post.val)"
                         [class.loading]="isUpdating[post.val.id + '_live']"
                         [style.pointer-events]="isUpdating[post.val.id + '_live'] ? 'none' : 'auto'">
                        <div class="slider"></div>
                        <button [class.selected]="post.val.live == '1'">
                            啟用
                        </button>
                        <button [class.selected]="post.val.live == '0'">
                            停用
                        </button>
                    </div>
                </div>

                <!-- Capture Media 狀態切換 -->
                <div *ngIf="post.key == 'capture_media'">
                    <div class="modern-toggle"
                         [ngClass]="post.val.capture_media == '1' ? 'active' : 'inactive'"
                         (click)="autoToggle('capture_media', post.val)"
                         [class.loading]="isUpdating[post.val.id + '_capture_media']"
                         [style.pointer-events]="isUpdating[post.val.id + '_capture_media'] ? 'none' : 'auto'">
                        <div class="slider"></div>
                        <button [class.selected]="post.val.capture_media == '1'">
                            啟用
                        </button>
                        <button [class.selected]="post.val.capture_media == '0'">
                            停用
                        </button>
                    </div>
                </div>

                <!-- Toy 狀態切換 -->
                <div *ngIf="post.key == 'toy'">
                    <div class="modern-toggle"
                         [ngClass]="post.val.toy == '1' ? 'active' : 'inactive'"
                         (click)="autoToggle('toy', post.val)"
                         [class.loading]="isUpdating[post.val.id + '_toy']"
                         [style.pointer-events]="isUpdating[post.val.id + '_toy'] ? 'none' : 'auto'">
                        <div class="slider"></div>
                        <button [class.selected]="post.val.toy == '1'">
                            啟用
                        </button>
                        <button [class.selected]="post.val.toy == '0'">
                            停用
                        </button>
                    </div>
                </div>
            </ng-template>
        </app-table-v2>
        <div  *ngIf="data.length == 0">
            目前無資料
        </div>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"  *ngIf="data.length > 0"></app-pagnation>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>




